"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en-US': {
        search: 'Search',
        selectAll: 'Select all',
        unselectAll: 'Unselect all',
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        language: 'Language',
        english: 'English',
        spanish: 'Spanish',
        catalan: 'Catalan',
        german: 'German'
    },
    'es-ES': {
        search: 'Buscar',
        selectAll: 'Seleccionar todo',
        unselectAll: 'Deseleccionar todo',
        sun: 'Dom',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mie',
        thu: 'Jue',
        fri: 'Vie',
        sat: 'Sab',
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre',
        language: 'Idioma',
        english: 'Inglés',
        spanish: 'Español',
        catalan: 'Catalan',
        german: 'Alemán'
    },
    'fr-FR': {
        search: 'Recherche',
        selectAll: 'Tout sélectionner',
        unselectAll: 'Tout déselectionner',
        sun: 'Dim',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Jeu',
        fri: 'Ven',
        sat: 'Sam',
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre',
        language: 'Langue',
        english: 'Anglais',
        spanish: 'Espanol',
        catalan: 'Catalan',
        german: 'Allemand'
    },
    'ca-ES': {
        search: 'Buscar',
        selectAll: 'Seleccionar tot',
        unselectAll: 'Deseleccionar tot',
        sun: 'Dom',
        mon: 'Dil',
        tue: 'Di',
        wed: 'Dim',
        thu: 'Dij',
        fri: 'Div',
        sat: 'Dis',
        january: 'Gener',
        february: 'Febrer',
        march: 'Març',
        april: 'Abril',
        may: 'Maig',
        june: 'Juny',
        july: 'Juliol',
        august: 'Agost',
        september: 'Septembre',
        october: 'Octubre',
        november: 'Novembre',
        december: 'Decembre',
        language: 'Idioma',
        english: 'Anglès',
        spanish: 'Espanyol',
        catalan: 'Català',
        german: 'Alemany'
    },
    'de-DE': {
        search: 'Buscar',
        selectAll: 'Seleccionar tot',
        unselectAll: 'Deseleccionar tot',
        sun: 'So',
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember',
        language: 'Sprache',
        english: 'Englisch',
        spanish: 'Spanisch',
        catalan: 'Katalanisch',
        german: 'Deutsche'
    }
};
//# sourceMappingURL=literals.js.map